import { Bot, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { StatusBadge } from '@/components/StatusBadge';
import { runRef } from '@/components/factory/run-status';
import { runPath } from '@/navigation/project-paths';

/**
 * T-41: on a comment for a run's working agent. "Sent to R-N" once it went in (the comment's
 * steered_run_number; steeredRunNumber from ./task-steer), "Waiting for R-N's agent" while the run holds
 * it until its agent works (held_run_number; heldRunNumber). Links to the run when the page knows the project.
 */
export function SteeredTag({
  runNumber,
  waiting = false,
  projectSlug,
  onNavigate,
}: {
  runNumber: number;
  /** Held: the agent gets it as soon as it's working. */
  waiting?: boolean;
  projectSlug?: string;
  onNavigate?: () => void;
}) {
  const run = runRef(runNumber);
  const hint = waiting ? `${run}'s agent gets this as soon as it's working` : `This went into ${run}'s agent while it worked`;
  const badge = (
    <StatusBadge tone={waiting ? 'neutral' : 'info'} size="sm" data-hint={hint}>
      {waiting ? <Clock className="size-3" /> : <Bot className="size-3" />}
      {waiting ? `Waiting for ${run}'s agent` : `Sent to ${run}`}
    </StatusBadge>
  );
  if (!projectSlug) return badge;
  return (
    <Link to={runPath(projectSlug, runNumber)} onClick={onNavigate} className="hover:opacity-80" aria-label={`${hint}: open ${run}`}>
      {badge}
    </Link>
  );
}
